// SidebarMenu.js

import React, { useState } from "react";
import { gql } from "@apollo/client";
import { client } from "../../../client";
import styled from "styled-components";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { uploadFileWithPresignedUrl } from "../../../utils/s3Uploader";
import FileUploader from "../admin-document/FileUploader";

const StyledFormContainer = styled.div`
  max-width: 400px;
  margin: 0 auto;
`;

const CREATE_BOOK = gql`
  mutation createBookExhibitionByAdmin(
    $type: Type!
    $is_view: Int!
    $view_order: Int
    $title: String!
    $description: String
    $object_url: String
    $sample_url: String
  ) {
    createBookExhibitionByAdmin(
      type: $type
      is_view: $is_view
      view_order: $view_order
      title: $title
      description: $description
      object_url: $object_url
      sample_url: $sample_url
    ) {
      message
    }
  }
`;

const CreateBook = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedSampleFile, setSelectedSampleFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    type: "SUPPORT",
    is_view: 1,
    view_order: null,
    title: "",
    description: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    let updatedValue = value;
    if (name === "is_view" || name === "view_order") {
      updatedValue = value ? parseInt(value, 10) : null;
    }
    setFormData({ ...formData, [name]: updatedValue });
  };

  const handleCreateBook = async () => {
    if (!formData.title) {
      alert("제목을 입력해주세요.");
      return;
    }

    setIsLoading(true);
    try {
      const uploadPromises = [];
      if (selectedFile) {
        uploadPromises.push(uploadFileWithPresignedUrl(client, selectedFile));
      } else {
        uploadPromises.push(Promise.resolve(null)); // 썸네일 파일이 없는 경우
      }

      if (selectedSampleFile) {
        uploadPromises.push(
          uploadFileWithPresignedUrl(client, selectedSampleFile)
        );
      } else {
        uploadPromises.push(Promise.resolve(null)); // 샘플 파일이 없는 경우
      }

      const [thumbnailUrl, sampleFileUrl] = await Promise.all(uploadPromises);

      await client.mutate({
        mutation: CREATE_BOOK,
        variables: {
          ...formData,
          object_url: thumbnailUrl,
          sample_url: sampleFileUrl,
        },
        fetchPolicy: "no-cache",
      });

      window.alert("자료가 성공적으로 등록되었습니다.");
      navigate("/admin/management-book"); // 등록 후 목록 페이지로 이동
    } catch (err) {
      alert(`자료 등록 중 오류가 발생했습니다: ${err.message}`);
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <h2>자료 등록</h2>
      <StyledFormContainer>
        <form>
          <FormControl fullWidth sx={{ marginBottom: 2 }}>
            <InputLabel id="type">Type</InputLabel>
            <Select
              labelId="type"
              id="type"
              name="type"
              value={formData.type}
              defaultValue={"SUPPORT"}
              label="type"
              onChange={handleChange}
            >
              <MenuItem value={"SUPPORT"}>지원</MenuItem>
              <MenuItem value={"SAMPLE"}>샘플</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth sx={{ marginBottom: 2 }}>
            <TextField
              label="제목"
              name="title"
              defaultValue={formData.title}
              onChange={handleChange}
              sx={{ marginBottom: 2 }}
            ></TextField>
          </FormControl>

          {/* <FormControl fullWidth sx={{ marginBottom: 2 }}>
            <TextField
              label="설명"
              name="description"
              defaultValue={formData.description}
              onChange={handleChange}
              sx={{ marginBottom: 2 }}
            ></TextField>
          </FormControl> */}

          <FormControl fullWidth sx={{ marginBottom: 2 }}>
            <InputLabel id="is_view">노출 여부</InputLabel>

            <Select
              labelId="is_view"
              id="is_view"
              name="is_view"
              value={formData.is_view}
              label="is_view"
              onChange={handleChange}
            >
              <MenuItem value={1}>노출</MenuItem>
              <MenuItem value={2}>비노출</MenuItem>
              {console.log(formData.is_view)}
            </Select>
          </FormControl>

          <FormControl fullWidth sx={{ marginBottom: 2 }}>
            <TextField
              label="노출 순서"
              name="view_order"
              defaultValue={formData.view_order}
              onChange={handleChange}
              sx={{ marginBottom: 2 }}
            ></TextField>
          </FormControl>

          <div>썸네일</div>
          <FileUploader
            selectedFiles={selectedFile ? [selectedFile] : []}
            setSelectedFiles={(files) => setSelectedFile(files[0] || null)}
          />
          <div style={{ marginTop: "16px" }}>샘플 파일</div>
          <FileUploader
            selectedFiles={selectedSampleFile ? [selectedSampleFile] : []}
            setSelectedFiles={(files) =>
              setSelectedSampleFile(files[0] || null)
            }
          />

          <Button
            variant="contained"
            onClick={handleCreateBook}
            disabled={isLoading}
            sx={{ mt: 2 }}
            fullWidth
          >
            {isLoading ? "등록 중..." : "자료 등록"}
          </Button>
        </form>
      </StyledFormContainer>
    </div>
  );
};

export default CreateBook;
